import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=2c5375ac&scoped=true&"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5375ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5375ac')) {
      api.createRecord('2c5375ac', component.options)
    } else {
      api.reload('2c5375ac', component.options)
    }
    module.hot.accept("./CopyToClipboard.vue?vue&type=template&id=2c5375ac&scoped=true&", function () {
      api.rerender('2c5375ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/CopyToClipboard.vue"
export default component.exports